import React, { ReactNode } from 'react';
import { TextStyle, ViewStyle } from 'react-native';
import { useNewUiTheme } from '../newUiTheme';

export interface BulletListProps {
  items: (string | ReactNode)[],
  style?: ViewStyle,
  itemStyle?: TextStyle,
  className?: string,
  itemClassName?: string,
}

export interface BulletListLayoutProps extends BulletListProps{

}

export function BulletList(props: BulletListProps) {
  const uiTheme = useNewUiTheme();
  return (
    <uiTheme.widgets.BulletListLayout
      {...props}
    />
  );
}
